import React from 'react';
import classes from './Footer.module.scss';
import {Link} from 'react-router-dom';
import FadeInUp from '../../FadeInUp';

const Footer = () => {
    return (
        <footer className={classes.footer}>
            <div className="container">
                <div className={classes.footer_inner}>
                    <FadeInUp className={classes.footer_logo}>
                        <Link to={'/'}>Logo</Link>
                    </FadeInUp>

                    <div className={classes.footer_middle}>
                        <FadeInUp className={classes.footer_middle_col}>
                            <Link to={'/services'} className={classes.footer_link}>Services</Link>
                            <Link to={'/platforms/shopify'} className={classes.footer_link}>Platforms</Link>
                            <Link to={'/industries'} className={classes.footer_link}>Industries</Link>
                        </FadeInUp>
                        <FadeInUp className={classes.footer_middle_col}>
                            <Link to={'/our-works'} className={classes.footer_link}>Our Work</Link>
                            <Link to={'/process'} className={classes.footer_link}>Process</Link>
                            <Link to={'/contact-us'} className={classes.footer_link}>Contact</Link>
                        </FadeInUp>
                    </div>

                    <div className={classes.footer_right}>
                        <FadeInUp>
                            <address className="font-500"> Amsterdam, The Netherlands</address>

                            <address className="font-500"> Valencia, Spain</address>

                            <a href="mailto:hello@onelabs.nl" className={classes.footer_link}>hello@onelabs.nl</a>
                        </FadeInUp>

                        <FadeInUp>
                            <ul className={classes.footer_social}>
                                <li className={classes.footer_social_item}>
                                    <a href="/" aria-label="linkedin" title="Linkedin" target="_blank">
                                        <img src="/images/linkeding.svg" width={20} height={20} alt=""/>
                                    </a>
                                </li>
                                <li className={classes.footer_social_item}>
                                    <a href="/" aria-label="instagram" title="Instagram" target="_blank">
                                        <img src="/images/instagram.svg" width={20} height={20} alt=""/>
                                    </a>
                                </li>
                                <li className={classes.footer_social_item}>
                                    <a href="/" aria-label="facebook" title="Facebook" target="_blank">
                                        <img src="/images/facebook.svg" width={20} height={20} alt=""/>
                                    </a>
                                </li>
                                <li className={classes.footer_social_item}>
                                    <a href="/" aria-label="twitter" title="Twitter" target="_blank">
                                        <img src="/images/twitter.svg" width={20} height={20} alt=""/>
                                    </a>
                                </li>
                            </ul>
                        </FadeInUp>
                    </div>
                </div>
            </div>

            <div className={classes.footer_copyright}>
                <div className="container">
                    <div className={classes.footer_copyright_inner}>
                        <p>&copy; 2025 OneLabs </p>

                        <a href="/" target="_blank">Privacy Policy</a>
                        <a href="/" target="_blank">Cookie Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;